import api from './api';

export interface WhitelistIp {
  _id: string;
  ip: string;
  description?: string;
  isActive: boolean;
  expiresAt?: string;
  type: 'single' | 'range';
  createdBy?: string;
  failedAccessCount?: number;
  lastFailedAccessAt?: string;
  createdAt: string;
  updatedAt: string;
}

export interface CreateWhitelistIpDto {
  ip: string;
  description?: string;
  expiresAt?: string;
  type?: 'single' | 'range';
}

export interface UpdateWhitelistIpDto {
  description?: string;
  isActive?: boolean;
  expiresAt?: string;
}

export interface WhitelistStats {
  total: number;
  active: number;
  expired: number;
  inactive: number;
}

export interface CheckIpResponse {
  ip: string;
  isWhitelisted: boolean;
  message: string;
}

export const whitelistApi = {
  // Get all whitelist IPs
  getAll: (filters: any = {}): Promise<WhitelistIp[]> => {
    const params = new URLSearchParams();
    if (filters.status) params.append('status', filters.status);
    if (filters.search) params.append('search', filters.search);
    if (filters.type) params.append('type', filters.type);
    
    return api.get(`/whitelist?${params.toString()}`);
  },

  // Get active whitelist IPs
  getActive: (): Promise<WhitelistIp[]> => {
    return api.get('/whitelist/active');
  },

  // Get whitelist statistics
  getStats: (): Promise<WhitelistStats> => {
    return api.get('/whitelist/stats');
  },

  // Get single whitelist IP
  getById: (id: string): Promise<WhitelistIp> => {
    return api.get(`/whitelist/${id}`);
  },

  // Create new whitelist IP
  create: (data: CreateWhitelistIpDto): Promise<WhitelistIp> => {
    return api.post('/whitelist', data);
  },

  // Update whitelist IP
  update: (id: string, data: UpdateWhitelistIpDto): Promise<WhitelistIp> => {
    return api.patch(`/whitelist/${id}`, data);
  },

  // Delete whitelist IP
  delete: (id: string): Promise<{ message: string }> => {
    return api.delete(`/whitelist/${id}`);
  },

  // Bulk delete whitelist IPs
  bulkDelete: (ids: string[]): Promise<{ message: string; deletedCount: number }> => {
    return api.delete('/whitelist/bulk', { data: { ids } });
  },

  // Check if IP is whitelisted
  checkIp: (ip: string): Promise<CheckIpResponse> => {
    return api.post('/whitelist/check', { ip });
  },

  // Get failed login statistics
  getFailedLoginStats: (): Promise<any> => {
    return api.get('/whitelist/failed-login-stats');
  },

  // Get whitelist status
  getStatus: (): Promise<{ enabled: boolean }> => {
    return api.get('/whitelist/status');
  },
};
